// AUTO-GENERATED by scripts/set-env.js (runs via the "prestart"/"prebuild" npm hooks).
// Do NOT edit this file by hand - your changes will be overwritten on the next
// `npm start` / `npm run build`.
//
// Values come from a `.env` file at the repo root (if present) or from real
// shell environment variables, e.g.:
//   API_URL=https://backend-io.awb.dev.inspera.com \
//   CURRENT_URL=https://originality-report.awb.dev.inspera.com \
//   IO_APPLICATION_URL=https://app-originality.awb.dev.inspera.com \
//   PRODUCTION=true \
//   npm run build
//
// See scripts/set-env.js for the full list of supported variables and defaults.
export const environment = {
  production: false,
  apiUrl: 'https://backend-io.awb.dev.inspera.com',
  currentUrl: 'https://originality-report.awb.dev.inspera.com',
  ioApplicationUrl: 'https://app-originality.awb.dev.inspera.com',
  standalone: true
};
